import { render, staticRenderFns } from "./topLeft.vue?vue&type=template&id=20cec278&scoped=true&"
import script from "./topLeft.vue?vue&type=script&lang=js&"
export * from "./topLeft.vue?vue&type=script&lang=js&"
import style0 from "./topLeft.vue?vue&type=style&index=0&id=20cec278&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cec278",
  null
  
)

export default component.exports